// extracted by mini-css-extract-plugin
export default {"mCard":"XC-z","image":"YC-z","imageNoBackground":"ZC-z","imageHasCategory":"_C-z","fullWidth":"aD-z"};